export default __webpack_public_path__ + "static/media/695.12691882.gif";